const CookingMethodModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    formData: [],
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload 
    },
    SET_FORMDATA: (state, payload) => {
      state.formData = payload 
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    INSERT: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/cooking/method/get`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        const response = await axios.delete(`/cooking/method/delete/${payload}`)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Deleted!',
            position: 'bottomRight'
          })
        }
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/cooking/method/insert`, payload)
        // console.log(response.data);
        if (response.data.message === true) {
          iziToast.success({
            title: 'Created!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx.match(payload))
    }
  }
}

export default CookingMethodModule



// WEBPACK FOOTER //
// ./src/store/modules/cooking/cooking_method.js